import { t } from 'i18next';
import { Card, Flex, Typography } from 'antd';
import { ChatMessage } from '../../types';
import { SendTranscript } from './SendTranscript';
import { Trans } from 'react-i18next';

function countWords(str: string) {
  return str.trim().split(/\s+/).length;
}
const READING_SPEED = 150; // words per min

export const ChatStats = ({
  messages,
  requestTranscript,
  canRequestTranscript,
}: {
  messages: ChatMessage[];
  requestTranscript: (email: string) => void;
  canRequestTranscript: boolean;
}) => {
  const countQuestions = messages?.filter((x) => Boolean(x.query))?.length ?? 0;

  const wordsCount =
    messages
      ?.filter((x) => Boolean(x.message))
      .map((x) => countWords(x.message))
      .reduce((acc, count) => acc + count, 0) ?? 0;
  const readingTime = (60000 * wordsCount) / READING_SPEED;
  const minutes = Math.floor(readingTime / 60000);
  const seconds = +((readingTime % 60000) / 1000).toFixed(0);
  const readingTimePretty =
    (minutes > 0 ? minutes + 'min' : '') +
    (seconds < 10 ? '0' : '') +
    seconds +
    's';

  if (countQuestions === 0 || wordsCount === 0) {
    return null;
  }

  return (
    <div style={{ position: 'absolute', left: -140, top: 225, width: 120 }}>
      <Flex vertical gap={10}>
        <Card
          size="small"
          styles={{ body: { paddingTop: 5, paddingBottom: 5 } }}
        >
          <Flex vertical gap={5}>
            <div>
              <Typography.Text
                type="secondary"
                style={{
                  textTransform: 'uppercase',
                  fontSize: 9,
                  letterSpacing: 1,
                }}
              >
                {t('questions')}
              </Typography.Text>
              <Typography.Text style={{ fontSize: 11, display: 'block' }}>
                {countQuestions}
              </Typography.Text>
            </div>
            <div>
              <Typography.Text
                type="secondary"
                style={{
                  textTransform: 'uppercase',
                  fontSize: 9,
                  letterSpacing: 1,
                }}
              >
                {t('readingTime')}
              </Typography.Text>
              <Typography.Text style={{ fontSize: 11, display: 'block' }}>
                <Trans
                  i18nKey={'readingTimeFormatted'}
                  wordsCount={wordsCount}
                  readingTimePretty={readingTimePretty}
                >
                  {{ wordsCount }}
                  {t('words \\u2022')}
                  {{ readingTimePretty }}
                </Trans>
              </Typography.Text>
            </div>
          </Flex>
        </Card>
        {canRequestTranscript && ( 
          <SendTranscript requestTranscript={requestTranscript} />
        )}
      </Flex>
    </div>
  );
};
